import { useSelector } from "react-redux";
import { RootState } from "../redux/reducers";
import { get } from "../libs/utils/object";
import { QuotationPopupState } from "../redux/quotation-popup/state";
import { LegalRepresentativePopupState } from "../redux/legal-representative-popup/state";
import { CustomerState } from "../redux/customer/state";
import { QuotationPaymentState } from "../redux/quotation-payment/state";
import { EmissionState } from "../redux/emission/state";
import { QuotationState } from "../redux/quotation/state";

export const useAppState = <AppStatePart, Result = AppStatePart>(
    appStatePart: keyof RootState,
    path?: Paths<AppStatePart>
): Result => {
    const stateSelected = useSelector<RootState, Result>((state) =>
        path
            ? get<Result>(state[appStatePart], path as any)
            : (state[appStatePart] as any)
    );
    return stateSelected;
};

export const useQuotationPopupState = <Result = QuotationPopupState>(
    path?: Paths<QuotationPopupState>
): Result => {
    const stateSelected = useAppState<QuotationPopupState, Result>(
        "quotationPopup",
        path
    );
    return stateSelected;
};

export const useLegalRepresentativePopupState = <
    Result = LegalRepresentativePopupState
>(
    path?: Paths<LegalRepresentativePopupState>
): Result => {
    const stateSelected = useAppState<LegalRepresentativePopupState, Result>(
        "legalRepresentativePopup",
        path
    );
    return stateSelected;
};

export const useCustomerState = <Result = CustomerState>(
    path?: Paths<CustomerState>
): Result => {
    const stateSelected = useAppState<CustomerState, Result>("customer", path);
    return stateSelected;
};

export const useQuotationPaymentState = <Result = QuotationPaymentState>(
    path?: Paths<QuotationPaymentState>
): Result => {
    const stateSelected = useAppState<QuotationPaymentState, Result>(
        "quotationPayment",
        path
    );
    return stateSelected;
};

export const useEmissionState = <Result = EmissionState>(
    path?: Paths<EmissionState>
): Result => {
    const stateSelected = useAppState<EmissionState, Result>("emission", path);
    return stateSelected;
};

export const useQuotationState = <Result = QuotationState>(
    path?: Paths<QuotationState>
): Result => {
    const stateSelected = useAppState<QuotationState, Result>(
        "quotation",
        path
    );
    return stateSelected;
};
